import {
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
} from 'reactstrap';
import { ChangeEvent } from 'react';

interface Props {
  label: string;
  value?: number;
  onChange?: (inputValue: number) => void;
  disabled?: boolean;
}

export default function InputPercentual({
  label,
  value,
  onChange,
  disabled,
}: Props): JSX.Element {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;

    const inputValue = e.target.value;

    if (inputValue === '') {
      onChange(0);
      return;
    }

    onChange(Number(inputValue));
  };

  return (
    <Row>
      <Col xs="6" md="7">
        <Label className="form-control-label float-right mt-3">{label}</Label>
      </Col>
      <Col xs="6" md="5">
        <InputGroup className="input-group-alternative">
          <Input
            disabled={disabled}
            type="number"
            step={0.01}
            value={value || ''}
            placeholder="0"
            onChange={handleChange}
          />
          <InputGroupAddon addonType="append">%</InputGroupAddon>
        </InputGroup>
      </Col>
    </Row>
  );
}
